<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
        <v-btn rounded dark v-on="on">
          <v-icon style="margin-right: 5px">mdi-timeline-clock-outline</v-icon>
          {{ $t('common.history') }}
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-timeline-clock-outline</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('common.history') }} - {{playerName}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">{{ $t('common.close') }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-timeline>
          <v-timeline-item v-for="(item, i) in history" :key="i" :color="item.color" small>
            <template v-slot:opposite>
              <span :class="`headline font-weight-bold ${item.color}--text`" v-text="item.Duration"></span>
            </template>
            <v-card color="#45afb754" dark>
              <v-card-title class="title">
                <span style="color:red;margin-right:10px;">{{ item.INI }}</span>
                <span style="color:green">{{ item.END }}</span>
                <comment-form :historyData="item" :onFinished="getData" />
              </v-card-title>
              <v-card-text
                class="white text--primary"
                 v-if="item.Comment"
              >
                <p>{{ item.Comment }}</p>
                <!-- <v-btn
                  style="margin-top:10px;"
                  :color="item.color"
                  class="mx-0"
                  fab
                  small
                  @click="handleEditComment(item)"
                >
                  <v-icon>mdi-comment-processing</v-icon>
                </v-btn>-->
                <!-- <comment-form :historyData="item" :onFinished="getData" /> -->
              </v-card-text>
            </v-card>
            <!-- <template v-slot:opposite>
              <span
                :class="`headline font-weight-bold ${item.color}--text`"
                v-text="item.Duration"
              ></span>
            </template>
            <div class="py-4" style="background-color: #ECECEC; border-radius:10px;">
              <center>
                <h4 :class="`headline font-weight-light mb-4 red--text`"><span style="color:red;margin-right:10px;">{{ item.INI }}</span><span style="color:green">{{ item.END }}</span></h4>
                <span v-if="item.Comment">
                  {{item.Comment}}
                </span>
                
              </center>
            </div>-->
          </v-timeline-item>
        </v-timeline>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from "@/services/api";
import CommentForm from "./CommentForm";
export default {
  name: "HistoryOffline",
  components: {
    CommentForm
  },
  props: {
    playerID: {
      type: String,
      required: true
    },
    playerName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      history: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    convertMinutes(value) {
      const d = Math.floor(value / 1440); // 60*24
      const h = Math.floor((value - d * 1440) / 60);
      const m = Math.round(value % 60);

      if (d > 0) {
        return `${d} d, ${h} h, ${m} m`;
      } else if (h > 0) {
        return `${h} h, ${m} m`;
      } else {
        return `${m} min`;
      }
    },
    getData() {
      api.getAll(`pings/${this.playerID}/history`, true, 1, 10000, "")
        .then(response => {
          this.history = response.map(item => {
            const a = item.Duration.split(":");
            const minutes = +a[0] * 60 + +a[1];
            item.Duration = this.convertMinutes(minutes);
            item.INI = `${new Date(item.Start)
              .toISOString()
              .split(".")[0]
              .replace("T", " ")}`;
            item.END = `${new Date(item.End)
              .toISOString()
              .split(".")[0]
              .replace("T", " ")}`;
            return item;
          });
          this.loading = false;
        });
    }
  }
};
</script>